$(document).ready(function () {
    $("#search-item").on("keyup", function () {
        let search = $(".search-item").val()
        let data = new FormData()
        data.append('search', search)
        $.ajax({
            url: '/get-authors',
            type: 'POST',
            dataType: 'json',
            data: {
                words: $(".search-item").val()
            },
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            success: function (data) {
                $(".author-card-container").empty()
                showCard(data)
            }
        });
    });


    function showCard(author) {
        let country;
        var card;
        $.each(author, function (index, value) {
            console.log(index,value)
            country = getValueCountry(value.country)
            card = `
        <div class="col-lg-4 col-md-6 col-sm-12 mb-4 author-card">
            <div class="profile-card bg-white shadow mb-4 text-center rounded-lg p-4 position-relative h-100">
                <div class="profile-card_image">
                <a href="/detalle/autor/${value.slug}" style="color: black">
                    <img src="images/autores/${value.avatar}" alt="${value.name}" class="mb-4 shadow">
                    </a>
                    </div>
                    <div class="profile-card_details">
                    <h3 class="mb-0">${value.name}</h3>
                    <p class="text-muted">${country === "NA" ? '' : country}</p>

                    <p class="text-muted" id="biography_limit-${value.slug}"> ${value.biography_limit ? value.biography_limit + '<br>' : ''}
                            ${value.biography_limit ? `<button class="btn btn-link" id="verMas" data-slug="${value.slug}">Ver mas</button>` : ''}
                        </p>
                    </p>
                    <div class="collapse" id="biography-full-${value.slug}">
                    <div class="card card-body" style="border:none">
                    <p class="text-muted" id="biography_limit-${value.slug}" style="text-align: justify">${value.biography}
                    <button class="btn btn-link" id="verMenos" data-slug="${value.slug}">Ver menos</button>
                    </p>
                    </div>
                    </div>
                </div>
                <div class="profile-card_social text-center p-4">

                    ${value.web ? `<a href="${value.web}" class="d-inline-block" target="_blank"><img src="images/social/web.png" alt="Web"></a>` : '' }
                    ${value.twitter ? `<a href="${value.twitter}" class="d-inline-block" target="_blank"><img src="images/social/twitter.png" alt="Twitter"></a>` : '' }
                    ${value.facebook ? `<a href="${value.facebook}" class="d-inline-block" target="_blank"><img src="images/social/facebook.png" alt="Facebook"></a>` : '' }
                </div>
            </div>
        </div> `
            ;
            $(".author-card-container").append(card);
        })
    }

    function getValueCountry(country) {
        if (country) {
            return country
        } else {
            return ""
        }
    }

    $(document).on('click', '#verMas', function () {
        let slug = $(this).data('slug')
        $("#biography-full-" + slug).show()
        $("#biography_limit-" + slug).hide()
    });

    $(document).on('click', '#verMenos', function () {
        let slug = $(this).data('slug')
        $("#biography-full-" + slug).hide()
        $("#biography_limit-" + slug).show()
    });

});

